import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "news_icon_left",
  "use": "news_icon_left-usage",
  "viewBox": "0 0 20 13",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 13\" id=\"news_icon_left\"><g stroke=\"#A8AAB3\" stroke-width=\"2\" stroke-linecap=\"round\"><path d=\"M19 6.5H1M6 11.5l-5-5M6 1.5l-5 5\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol